import {
  getBuddyPromise,
  getUserPromise,
  getGroupsPromise,
} from "./dummy-data/dummy-promise";

class UserLibrary {
  getBuddy(username) {
    return getBuddyPromise(username);
  }

  getUser(username) {
    return getUserPromise(username);
  }

  getGroups(username) {
    return getGroupsPromise(username);
  }
}

export default UserLibrary;
